import { ConfirmPickupState } from './confirmPickup.types'

export const confirmPickupInitialState: ConfirmPickupState = {
  loading: false,
  error: null,
  success: null
}

export default confirmPickupInitialState
